import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-usr-accountsummery',
  templateUrl: './usr-accountsummery.component.html',
  styleUrls: ['./usr-accountsummery.component.css']
})
export class UsrAccountsummeryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    window.scrollTo(0, 0);
  }

}
